export function getAccountPromos(account) {
  const promos = Array.isArray(account.redeemed_promo_codes)
    ? account.redeemed_promo_codes
    : [];
  const pendingCode = account.pending_promo_code;

  return pendingCode && !promos.some((promo) => promo.promo_code === pendingCode)
    ? [...promos, { promo_code: pendingCode }]
    : promos;
}
